




import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ButtonsToggle extends Vue {
    @Prop({default: 'medium'}) public size: any;
    @Prop({default: 'success'}) public type: any;

    get typeClass(): string {
        switch (this.type) {
            case 'success':
                return 'hoc-badge-success';
        }
    }
}
